export const endpoints = {
  query: '/serviceOrder/query',
  find: '/serviceOrder/find/:id',
  queryNotes: '/serviceOrder/:id/notes',
  getHistory: '/serviceOrder/history/:id',
  createNotes: '/serviceOrder/:id/notes',
  persistImage: '/image',
}
